// Restricted rows of Tapestry boxes while writing live (docs/live-design.md §3.4): in the shared text they're locked
// placeholders (:::hidden {ref="…" rows="yes"}); the rows a person may see are parts of their own, which the live session
// opens for them. The panels show them by expanding the placeholders, and write them back to their parts. Outside a live
// session nothing changes: rows are just the box's text.

import { writeRows, type Placed } from "./rows.js";

export type RowsPart = { key: string; to: string };

export interface LiveRows {
  /** The rows with the parts this person may see put back in place (as :::restricted blocks), and which those were. */
  expand(rows: string): { rows: string; parts: RowsPart[] };
  /** The box's rows as the panel has them, written back: each visible part's rows to that part, the rest as the shared text. */
  collapse(placed: Placed[], hidden: string[], parts: RowsPart[]): string;
}

const plain: LiveRows = {
  expand: (rows) => ({ rows, parts: [] }),
  collapse: (placed, hidden) => writeRows(placed, hidden),
};

let current: LiveRows = plain;

export const liveRows = {
  get: (): LiveRows => current,
  set(rows: LiveRows | null): void {
    current = rows ?? plain;
    // Every panel reads its rows again.
    document.dispatchEvent(new CustomEvent("p9-live-rows"));
  },
  /** A part's rows changed (someone else wrote them): the panels read again. */
  changed(): void {
    document.dispatchEvent(new CustomEvent("p9-live-rows"));
  },
};
